import * as React from 'react';
import { withStyles } from '@material-ui/core';
import { SHIPMENT_ISSUES } from '../../../utils';

const styles = (theme: any) => ({
  tagContainer: {
    padding: '2px 8px',
    borderRadius: '14px',
    backgroundColor: theme.errorBGColorSecondary,
    color: theme.printTableLabel,
    fontSize: theme.textFontSize,
    marginRight: 5
  }
});

interface ShipmentIssuesRendererProps {
  classes: any;
  data: any;
}

const ShipmentIssuesRenderer = ({ classes, data }: ShipmentIssuesRendererProps) => {
  const { shipmentIssues } = data;
  
  if (SHIPMENT_ISSUES.every((issue) => shipmentIssues[issue.key] === 0)) {
    return <div>None</div>;
  }

  return (
    <div>
      {SHIPMENT_ISSUES.filter((issue) => shipmentIssues[issue.key] > 0).map((issue) => (
        <span className={classes.tagContainer}>{issue.label}</span>
      ))}
    </div>
  );
};

export default withStyles(styles)(ShipmentIssuesRenderer);
